export type ParseContentImagesProps = {
    url?: string
    publicURL?: string
}

const parseContentImages = (content?: string, contentImages?: ParseContentImagesProps[]) => {
    if (!content) {
        return ""
    }

    if (!contentImages) {
        return content
    }

    let newContent = content

    contentImages?.forEach((image) => {
        const searchUrl = image?.url?.replace(`${process.env.GATSBY_STRAPI_URL}`, "")

        if (searchUrl) {
            newContent = newContent.replace(image?.url, image?.publicURL).replace(searchUrl, `${image?.publicURL}`)
        }
    })

    return newContent
}

export default parseContentImages
